import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b94e152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "transition-box" }
const _hoisted_4 = { class: "loader-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("div", null, [
              _withDirectives(_createElementVNode("div", { class: "head" }, _toDisplayString(_ctx.header), 513), [
                [_vShow, _ctx.header]
              ]),
              _renderSlot(_ctx.$slots, "content", {}, undefined, true)
            ], 512), [
              [_vShow, !_ctx.loading]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
              [_vShow, _ctx.loading]
            ])
          ])
        ], 512), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 3
    }),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, null, 512), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 1
    })
  ]))
}